import { styled } from "@mui/material/styles";
import TextField from "@mui/material/TextField";

const SearchField = styled(TextField)({
  "& .MuiOutlinedInput-root": {
    paddingTop:0,
    paddingBottom:0,
    backgroundColor: "#fff",
    borderRadius:24,
    border:'1px solid #ACACAC',
    "& fieldset": {
      borderRadius:24,
      border:'1px solid #ACACAC',
    },
    "&:hover fieldset": {
      borderColor: "primary", // Hover border color
    },
    "&.Mui-focused fieldset": {
      borderColor: "primary", // Focused border color
    },
  },
  "& .MuiInputBase-root":{
    // paddingTop:0,
    // paddingBottom:0,
    maxHeight:'40px'
  },

  "& .MuiInputLabel-root": {
    color: "gray", // Label color
  },
  "& .MuiInputLabel-root.Mui-focused": {
    color: "primary", // Focused label color
  },
});

export default SearchField;
